import { render, staticRenderFns } from "./RModalSubHeader.vue?vue&type=template&id=f17c9fc0&scoped=true"
import script from "./RModalSubHeader.vue?vue&type=script&lang=js"
export * from "./RModalSubHeader.vue?vue&type=script&lang=js"
import style0 from "./RModalSubHeader.vue?vue&type=style&index=0&id=f17c9fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17c9fc0",
  null
  
)

export default component.exports